import {h} from 'preact';
import {useCalculatorContext} from '../context';
import {Kit, VendorCatalog} from '../types';
import {actions} from '../reducer';
import {sortVendorsByAlphabet} from '../../../utils';
import {useEffect, useState} from 'preact/hooks';

type KitProps = {
  item: Kit;
  currentKitIndex: number;
  sum: number;
  index: number;
}

function Kit(props: KitProps) {
  const {item, sum, index, currentKitIndex } = props;
  const {state: {serviceKits, currentVendors, currentVendorIndex, optionsSum, productsSum}, dispatch} = useCalculatorContext();
  const [total, setTotal] = useState(optionsSum + productsSum)

  useEffect(() => {
    setTotal(() => optionsSum + productsSum)
  },[currentVendors])


  function changeKit(index: number) {
    dispatch(actions.setCurrentKitIndex(index));
    dispatch(actions.setCurrentVendorIndex(0));
    dispatch(actions.setCurrentVendor(
        sortVendorsByAlphabet(item.vendors)[0]
      )
    );
    dispatch(
      actions.setCurrentProducts(
        sortVendorsByAlphabet(item.vendors)[0].products
      )
    );

    dispatch(
      actions.setCurrentOptions(serviceKits[index].options)
    );
    dispatch(
      actions.setOptionsSum(item.subscription_min)
    )
  }
  
  return (
    <>
      <div 
        className={`kit-price ${( currentKitIndex === index ) ? ( "active" ) : ""}`} 
        onClick={() => changeKit(index)}
      >
        <span className="kit-button-text">
          { 
            ( item.name === "Default" ) ? (  "Базовый комплект " ) : ( `${item.name} ` )  
          }
        </span>
      </div>
    </>
  );
}

export {Kit};
